<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-2xl mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody> Acc order mappings </BaseCardBody>
        <BaseCardBody clear-padding>
          <div class="divide-y divide-gray-200">
            <div>
              <div class="bg-gray-50 flex">
                <div
                  class="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </div>
                <div
                  class="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Series
                </div>
                <div class="w-40 px-6 py-3" />
              </div>
            </div>
            <div>
              <AccOrderStatusDocumentSeriesMappingCreateForm
                :key="accOrderStatusToDocumentSeries.length + 1"
                :soft-one-service-id="thirdPartyServiceId"
                :series-options="documentSeriesOptions"
                :status-options="statusOptions"
                :disabled="lockCreate"
              />
            </div>
            <div>
              <AccOrderStatusToDocumentSeriesUpdateForm
                :soft-one-service-id="thirdPartyServiceId"
                :initial-data="accOrderStatusToDocumentSeries"
                :series-options="documentSeriesOptions"
                @updating="lockCreate = true"
                @updated="lockCreate = false"
              />
            </div>
          </div>
        </BaseCardBody>
        <BaseCardBody>
          <BaseButton primary @click="$refs.modal.close()"> Close </BaseButton>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import statusOptions from '@/utils/woocommerce-statuses';
import AccOrderStatusDocumentSeriesMappingCreateForm from './AccOrderStatusDocumentSeriesMappingCreateForm.vue';
import AccOrderStatusToDocumentSeriesUpdateForm from './AccOrderStatusToDocumentSeriesUpdateForm.vue';

export default {
  components: {
    AccOrderStatusDocumentSeriesMappingCreateForm,
    AccOrderStatusToDocumentSeriesUpdateForm,
  },
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lockCreate: false,
    };
  },
  computed: {
    thirdPartyService() {
      return this.$store.state.entities.thirdPartyServices.byId[this.thirdPartyServiceId] || null;
    },
    documentTypes() {
      return this.thirdPartyService?.config?.documentTypes || [];
    },
    documentSeriesOptions() {
      return this.documentTypes.map((documentType) => ({
        value: documentType.number,
        label: documentType.name,
      }));
    },
    accOrderStatusToDocumentSeries() {
      return this.thirdPartyService?.config?.accOrderStatusToDocumentSeries || [];
    },
    statusOptions() {
      const excludedStatuses = this.accOrderStatusToDocumentSeries.map((x) => x.status);

      return statusOptions.filter((s) => excludedStatuses.indexOf(s.value) === -1);
    },
  },
};
</script>
